export class TextValidate {
  public static EMAIL_REGX = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  public static validation(title: string, value?: string, required?: boolean, maxLength?: number, minLength?: number, regexp?: RegExp): { hasErrors: boolean; messages: string[] } {
    const errors: string[] = [];

    if (value) {
      if (required && value.length < 1) {
        errors.push(`${title}は必ず入力してください`);
      }
      if (maxLength && value.length > maxLength) {
        errors.push(`最大文字数は${maxLength}文字です`);
      }
      if (minLength && value.length < minLength) {
        errors.push(`少なくとも${minLength}文字入力してください`);
      }
      console.log(regexp, regexp && value.match(regexp));
      if (regexp && !value.match(regexp)) {
        if (regexp === this.EMAIL_REGX) {
          errors.push(`メールアドレスの形式が正しくありません`);
        } else {
          errors.push(`入力が正しくありません`);
        }
      }
    } else if (required) {
      console.log(value);
      errors.push(`${title}は必ず入力してください!`);
    }

    const hasError = errors.some((i) => (i ? true : false));

    return { hasErrors: hasError, messages: errors };
  }
}
